
import { VisibleLinks } from "@/models/user-configs/visible-links";
import { UserConfigService } from "@/services";
import Vue from "vue";

export default Vue.extend({
	data(){
		return {
			settings: new VisibleLinks(),
			justFetched: false,
			UserConfigService
		};
	},
	props: {
		userId: Number
	},
	computed: {
		storedVisibleLinks():VisibleLinks {
			return UserConfigService.getVisibleLinks();
		}
	},
	watch: {
		userId: {
			immediate: true,
			handler(){
				this.fetchSettings();
			}
		},
		settings: {
			deep: true,
			handler(){
				if (this.justFetched) {
					this.justFetched = false;
					return;
				}
				this.saveSettings();
			}
		},
		storedVisibleLinks(){
			if (!this.userId ) return;
			this.fetchSettings();
		}
	},
	methods: {
		async fetchSettings(){
			if (!this.userId){
				var settings = UserConfigService.getVisibleLinks();
			}else {
				var settings = await UserConfigService.getUsersVisibleLinksm(this.userId);
			}
			this.justFetched = true;
			this.settings = settings;
		},
		async saveSettings(){
			if (!this.userId){
				await UserConfigService.setVisibleLinks(this.settings);
			}else{
				await UserConfigService.setUserVisibleLinks(this.userId, this.settings);
			}
		}
	},
	i18nEx: {
		componentPrefix: "components.settings-default.VisibleLinks"
	}
});
